import { Component, Input, OnInit } from '@angular/core';

import { ChatSocketService } from '../../services/chat-socket.service';

@Component({
  selector: 'chat-workspace',
  templateUrl: 'chat-workspace.component.html',
  styleUrls: ['./chat-workspace.component.scss'],
})
export class ChatWorkspaceComponent implements OnInit {
  @Input()
  public responseId: string;

  public extendMirror = false;

  constructor(public readonly chatSocketService: ChatSocketService) {}

  ngOnInit(): void {
    if (!this.responseId) {
      return;
    }
    const chatModel = this.chatSocketService.getChatByResponseId(this.responseId);
    if (chatModel) {
      this.chatSocketService.selectChat(chatModel);
    }
  }
}
